import { Pipe, PipeTransform } from '@angular/core';
import { ListItem } from 'src/app/controls/filters/models/list-item';

@Pipe({
    name: 'listItem',
    standalone: true,
})
export class ListItemPipe implements PipeTransform {
    transform<T>(value: T, items: ListItem<T>[]): string {
        return items.find((x) => x.value === value).text;
    }
}
